export enum PageType {
  EVENTS = 'events',
  COLLECTION = 'collection',
  HOME = 'home'
}

export enum SortType {
  GLOBAL_SCORE = 'global-score-norm',
  LOCATION_SCORE = 'location_score',
  DAY_TRENDING_SCORE = 'day-trending-score'
}
